import * as types from './mutation-types.js'

const state = () => ({
    hashes: []
})

const actions = {
    fetchAll({ commit }) {
        return axios.get('Hashes').then(response => {
            commit(types.STORE_HASHES, response.data);
            return response.data
        })
    },
};

const mutations = {
    [types.STORE_HASHES](state, hashes) {
        state.hashes = hashes;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};